import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import Button from '../Button';
import * as Style from './style';

const ModalDeleteLogo = ({
    isOpen, openAction, logo, deleteAction,
}) => {
    const closeModal = () => openAction(false);
    const { id } = logo;

    const deleteLogo = () => {
        const deleteLogoPromise = new Promise((resolve) => {
            deleteAction(id);
            resolve();
        });
        deleteLogoPromise.then(() => openAction(false));
    };

    return (
	<Modal isOpen={isOpen} openAction={openAction} borderRadius="4px">
		<Style.Content>
			<div className="row" style={{ marginBottom: '20px' }}>
				<div className="col-12">
					<Style.Label>Tem certeza que deseja excluir essa logo?</Style.Label>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
					<Button onClick={closeModal} fontSize="15px" padding="8px 0" bordered theme="light2">Cancelar</Button>
				</div>
				<div className="col-6">
					<Button onClick={deleteLogo} fontSize="15px" padding="8px 0">Excluir logo</Button>
				</div>
			</div>
			<Style.CloseButton onClick={closeModal} />
		</Style.Content>
	</Modal>
    );
};

PropTypes.ModalDeleteLogo = {
	isOpen: PropTypes.bool.isRequired,
	openAction: PropTypes.func.isRequired,
	logo: PropTypes.object.isRequired,
	deleteAction: PropTypes.func.isRequired,
};

export default ModalDeleteLogo;
